module.exports = __webpack_public_path__ + "img/video.69b1fa1b.svg";